import _ from 'lodash';
import {
    Group,
    GroupBulkAssignWorkspacesRequest, GroupBulkDeleteRequest,
    GroupCollection, GroupCreationRequest, GroupsClient, GroupUpdateRequest,
    IGroupCreationRequest, IGroupUpdateRequest, Workspaces2,
} from '../clients/aasServerClient.generated';
import { TableFilters, TableSorting } from '../stores/tables/state';

export function getGroups(
    limit: number, start: number,
    sorting: TableSorting,
    filters: TableFilters,
    searchString?: string
): Promise<GroupCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.getGroups(
        false, true,
        limit, start, ordering,
        filters.u, filters.w,
        searchString
    );
}

export function getGroupsWoFilters(
    limit: number, start: number,
    sorting: TableSorting,
    
    searchString?: string
): Promise<GroupCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.getGroups(
        false, true,
        limit, start, ordering,
        undefined, undefined,
        searchString
    );
}


export  async function getgroupsId(searchString: string,filters: TableFilters) : Promise<string []>
{
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    let groups = await client.getGroups(false,undefined,undefined,undefined,undefined,filters.u, filters.w,searchString);
    let ret: string [] = [] ;
    groups.items.forEach(element => {ret.push( element.id)});
    return ret;
}

export function getAllGroups(): Promise<GroupCollection> {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.getGroups(
        true, undefined,
        undefined, undefined, undefined,
        undefined, undefined,
        undefined
    );
}

export function getGroupsPerWorkspace(ids: string[]): Promise<GroupCollection> {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
        return client.getGroupsByWorkspace(
            ids     
        );
}

export function getGroup(id: string): Promise<Group> {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.getGroup(id);
}

export function updateGroup(
    group: Partial<Group>,
    workspaces?: Array<{ id: string, value: boolean }>,
): Promise<Group> {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    const data: IGroupUpdateRequest =
        _.assign(group, {
            workspaces: workspaces ? workspaces.map((w) => new Workspaces2(w)) : undefined,
        }) as unknown as IGroupUpdateRequest;
    return client.updateGroup(group.id!, new GroupUpdateRequest(data));
}

export function createGroup(
    group: Partial<Group>,
    workspaces?: Array<{ id: string, value: boolean }>,
): Promise<Group> {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    const data: IGroupCreationRequest =
        _.assign(group, {
            workspaces: workspaces ? workspaces.map((w) => new Workspaces2(w)) : undefined,
        }) as unknown as IGroupCreationRequest;
    return client.createGroup(new GroupCreationRequest(data));
}

export function deleteGroups(ids: string[]) {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeleteGroups(new GroupBulkDeleteRequest({ ids }));
}

export function assignGroupsWorkspace(groupIds: string[], workspaceIds: string[]) {
    const client = new GroupsClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignWorkspace2(
        new GroupBulkAssignWorkspacesRequest({ groups: groupIds, workspaces: workspaceIds })
    );
}
